var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructionsEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2048_15872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8837 21.246L6.16943 21.6546L6.578 16.9403L16.3837 7.19741C16.5301 7.04774 16.7048 6.92882 16.8978 6.84763C17.0907 6.76643 17.298 6.72461 17.5073 6.72461C17.7166 6.72461 17.9238 6.76643 18.1168 6.84763C18.3097 6.92882 18.4845 7.04774 18.6309 7.19741L20.6266 9.20884C20.7737 9.35503 20.8904 9.52887 20.9701 9.72035C21.0497 9.91183 21.0907 10.1172 21.0907 10.3246C21.0907 10.5319 21.0497 10.7373 20.9701 10.9288C20.8904 11.1202 20.7737 11.2941 20.6266 11.4403L10.8837 21.246Z",
    stroke: "#2173FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.32383 6.7418C0.772263 6.64594 0.772263 5.85394 1.32383 5.75808C2.30045 5.58811 3.20433 5.13116 3.92023 4.44548C4.63613 3.7598 5.13163 2.87646 5.34355 1.90808L5.37655 1.75565C5.49598 1.21194 6.27226 1.20723 6.39798 1.75251L6.43726 1.92851C6.65695 2.89258 7.15659 3.77026 7.87343 4.45131C8.59027 5.13237 9.49236 5.58644 10.4664 5.75651C11.0211 5.8508 11.0211 6.64751 10.4664 6.74494C9.49228 6.91462 8.58999 7.36833 7.87287 8.04911C7.15575 8.72989 6.65576 9.60737 6.43569 10.5714L6.39483 10.7489C6.27069 11.2927 5.49441 11.2895 5.37498 10.7442L5.34355 10.5918C5.13142 9.62299 4.63545 8.73934 3.91895 8.05362C3.20244 7.3679 2.29788 6.9112 1.32069 6.7418H1.32383Z",
    stroke: "#04245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2048_15872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionsEditIcon);
export default __webpack_public_path__ + "static/media/instructions_edit_icon.d426ffb01a2664d63c2a2acae7b8b8c5.svg";
export { ForwardRef as ReactComponent };